module.exports = __webpack_public_path__ + "static/media/pwdpolicy.3c9d2617.svg";